class MenuToggle extends HTMLElement {
  constructor() {
    super();

    let activeMenu = window.localStorage.getItem('activeMenu');
    this.buttons = this.querySelectorAll('button');

    this.listeners();

    if (activeMenu) {
      this.toggleMenu(activeMenu);
    } else {
      let initialMenu = document.querySelectorAll('menu-toggle button')[0].dataset.menuName;
      this.toggleMenu(initialMenu);
    }

  }

  listeners() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.toggleMenu);
    });
  }

  toggleMenu(activeMenu) {
    if (!this.classList.contains('is-active')) {
      let allButtons = document.querySelectorAll('menu-toggle button');
      let allMenus = document.querySelectorAll('.js-menu-switch');
      let thisButton = this.dataset.menuName || activeMenu;

      let activeButton = document.querySelector('button[data-menu-name="' + thisButton + '"]')

      // Add 'is-active' class to selected button
      activeButton.classList.add('is-active');

      // Add localstorage to remember selection
      window.localStorage.setItem('activeMenu', thisButton);

      //Show/Hide Menu
      allMenus.forEach((menu) => {
        if (menu.dataset.menuName == thisButton) {
          menu.classList.remove('is-hidden')
        } else {
          menu.classList.add('is-hidden');
        }
      });

      // Remove 'is-active' class from other buttons
      allButtons.forEach((btn) => {
        if (btn != activeButton) {
          btn.classList.remove('is-active');
        }
      });

      document.dispatchEvent(new CustomEvent('make-it-snow'));
      
      let activeButtonUrl = activeButton.dataset.menuUrl;
      let currentUrl = window.location.pathname;

      if (activeMenu.type == 'click') {
        if (activeButtonUrl != '' && activeButtonUrl != currentUrl) {
          window.location.href = activeButtonUrl;
        }
      }
    }
  }

}

customElements.define('menu-toggle', MenuToggle);